<template>
    <div class="notification-permission">
      <div class="card text-center">
        <h3 class="mb-3">Allow Notifications</h3>
        <p class="mb-3 fz-18">We would like to send you important notifications.<br>Would you like to enable notifications?</p>
        <div class="d-flex justify-content-center align-items-center">
          <button @click="dismiss" class="btn bg-red mx-2">Not Allow</button>
          <button @click="requestPermission" class="btn bg-approve px-4 mx-2">Allow</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { isMobileSafari } from "@/util/browser";

  export default {
    methods: {
      async requestPermission() {
        if (isMobileSafari() && window.safari && window.safari.pushNotification) {
          // APNs: Safari iOS
          const permissionData = window.safari.pushNotification.permission("web.io.cgtechnology.rc-ui");
          const baseURL = (process.env.VUE_APP_ENVIRONMENT == "production")?
          "https://api.rcpaylink.com":(process.env.VUE_APP_ENVIRONMENT == "development"?
          "https://rc-crm.cgtechnology.io":"http://rc-crm.test");

          if (permissionData.permission === "default") {
            window.safari.pushNotification.requestPermission(
              baseURL+"/v1/member/safari-push",
              "web.io.cgtechnology.rc-ui",
              async (permission) => {
                console.log("Safari Permission Response:", permission);

                if (permission.permission === "granted") {
                  const deviceToken = permission.deviceToken;
                  localStorage.setItem("notification_token", deviceToken);
                  localStorage.setItem("permission", "true");

                  this.$emit("permission-granted");
                } else {
                  this.$emit("permission-denied");
                }
              }
            );
          } else {
            console.log("Permission already:", permissionData.permission);
            this.$emit(permissionData.permission === "granted" ? "permission-granted" : "permission-denied");
          }

          return;
        }

        if ("Notification" in window) {
          const permission = await Notification.requestPermission();
          localStorage.setItem("permission", permission === "granted" ? "true" : "false");
          this.$emit(permission === "granted" ? "permission-granted" : "permission-denied");
        } else {
          console.warn("Notification API tidak tersedia");
          this.$emit("permission-denied");
        }
      },
      dismiss() {
        this.$emit('permission-denied');
      }
    }
  };
  </script>
  
  <style scoped>
  .notification-permission {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10000001;
    height: 100%;
    background: rgba(0, 0, 0, .6);
  }
  .notification-permission .card{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-color: #fff;
    padding: 20px;
    border-radius: 18px;
  }
  .card h3 {
    margin: 0;
  }
  .card button {
    margin-right: 10px;
    padding: 5px 10px;
  }
  </style>
  